import { processingService } from '@shared/api';

import type { Client } from '../model/types';

export type GetMyClientsResponse = Client[];

export const getMyClients = () =>
  processingService
    .get<GetMyClientsResponse>('/clients/my')
    .then((response) => response.data);
